<template>
    <div :id="`k-dlg--${name}`" class="k-dlg-mask">
        <div class=" k-dlg-box center">
            <div class="k-dlg__head">
                <div class="k-dlg__title">
                    <h4>{{title}}</h4>
                </div>
                <a v-if="iconClose !== false" class="k-dlg__close" @click="close"><span>关闭</span></a>
            </div>
            <div class="k-dlg__body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'k-dlg',
        props: ['name', 'title', 'iconClose'],
        methods: {
            close() {
                this.$emit('close', this.name);
            }
        }
    };
</script>
